import { render, staticRenderFns } from "./pageFloatingAperture.vue?vue&type=template&id=036bcca8&scoped=true"
import script from "./pageFloatingAperture.vue?vue&type=script&lang=js"
export * from "./pageFloatingAperture.vue?vue&type=script&lang=js"
import style0 from "./pageFloatingAperture.vue?vue&type=style&index=0&id=036bcca8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036bcca8",
  null
  
)

export default component.exports